<template>
  <div class="local-admin__users-list">
    <r-title
      v-if="!activeState"
      style="padding-left:8px;margin-bottom:4px"
      type="subtitle-2"
    >
      {{ $t("users-list-title") }}
    </r-title>
    <r-title
      v-else
      type="subtitle-2"
      style="padding-left:8px;margin-bottom:4px"
    >
      {{ $t("users-list-title:selected") }}
    </r-title>
    <div class="local-admin__users-list__controls">
      <r-search-input
        :filter-text="filterText"
        @change="e => filterChange(e)"
      />
    </div>
    <scrollbar :scrolling-x="false">
      <ul class="local-admin__users-list__wrapper">
        <user-card
          v-for="user in filteredUsers"
          :key="user.id"
          :user="user"
          :clickHandler="clickHandler"
          :isActive="observActive(user.id)"
        />
        <div
          class="local-admin__users-list__empty"
          v-if="!filteredUsers.length"
        >
          <r-text type="caption" v-if="!filterText.trim()">
            {{ $t("users-list:users-notfound") }}
          </r-text>
          <r-text type="caption" v-else>
            {{ $t("users-list:users-filter-notfound") }}
          </r-text>
        </div>
      </ul>
    </scrollbar>
  </div>
</template>

<script>
import userCard from "./local-admin-users-item";
import scrollbar from "@/components/scrollbar/scrollbar";

export default {
  props: {
    users: { type: Array },
    activeState: { type: Boolean, default: false }
  },
  components: { scrollbar, userCard },
  data() {
    return {
      filterText: "",
      isChanged: false
    };
  },
  computed: {
    filteredUsers() {
      return this.users
        .filter(
          e =>
            e.name.toLowerCase().indexOf(this.filterText.toLowerCase().trim()) >
              -1 &&
            e.id !== this.activeUser.id &&
            this.observActive(e.id) === this.activeState
        )
        .sort((a, b) => {
          if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
          if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
          return 0;
        });
    },
    activeUser() {
      return this.$store.state.userRoles.activeUser;
    },
    initialActiveUser() {
      return this.$store.state.userRoles.initialUser;
    },
    managedUsers() {
      return this.activeUser.managed_users;
    }
  },
  methods: {
    filterChange(e) {
      this.filterText = e;
    },
    clickHandler(user) {
      const index = this.managedUsers.findIndex(e => e.user_id === user.id);
      const activeBefore = !!this.initialActiveUser.managed_users.find(
        e => e.user_id === user.id
      );

      if (activeBefore) {
        this.managedUsers.forEach((e, i) => {
          if (e.user_id === user.id)
            this.managedUsers[i].disabled = !this.managedUsers[i].disabled;

          return e;
        });
      } else {
        if (index > -1) {
          this.managedUsers.splice(index, 1);
        } else {
          this.managedUsers.push({ user_id: user.id });
        }
      }
    },
    observActive(userId) {
      return !!this.managedUsers.find(e => e.user_id === userId && !e.disabled);
    }
  }
};
</script>

<style lang="scss">
.local-admin__users-list {
  max-width: 280px;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid;
  border-radius: var(--border-radius);
  border-color: var(--dividers_low_contrast) !important;
  padding: 4px 0 4px 4px;
  overflow: hidden;
  margin-right: 12px;
  &:last-child {
    margin-right: 0;
  }
  .ritm-scrollbar {
    max-height: calc(100% - 54px);
  }
  &__wrapper {
    padding: 0 12px 0 8px;
    height: calc(100vh - 300px);
  }
  &__controls {
    position: relative;
    margin-bottom: 8px;
    padding: 0 12px 0 8px;
    .r-input {
      input {
        padding-left: 32px;
      }
    }
    .r-input__filter-icons {
      position: absolute;
      top: 4px;
      left: 16px;
      height: calc(100% - 8px);
      width: 12px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
    }
  }
  .local-admin__users-list__empty {
    min-height: 50%;
    max-width: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin: 0 auto;
    .r-text.caption-2 {
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .r-block-title {
    margin-bottom: 8px;
    text-transform: none;
    font-size: 12px;
    letter-spacing: initial;
    &:before {
      content: none;
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "users-list:users-notfound": "Пользователи отсутствуют",
    "users-list:users-filter-notfound": "По Вашему запросу пользователи не найдены",

    "users-list-title": "Список всех пользователей",
    "users-list-title:selected": "Выбранные пользователи"
  },
  "en": {
    "users-list:users-notfound": "No users",
    "users-list:users-filter-notfound": "No users found by your request",

    "users-list-title": "Users list",
    "users-list-title:selected": "Selected users"
  }
}
</i18n>
